import axios from "axios";
import Config from "../../../config";

const v2_actionListaLeads = (querys) => {
    
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/crm/leads/lista${querys ? querys : ''}`
    });
};

export default v2_actionListaLeads;
